import { useState, useEffect } from 'react';
import api from '../utils/api';
import { useAuth } from '../store/auth';
import { useSite } from '../store/site';
import { useNavigate } from 'react-router-dom';
import PlanView from '../components/PlanView';


export default function Dashboard() {
  const { user, logout } = useAuth();
  const { site, setSite } = useSite();
  const nav = useNavigate();
  const [sites, setSites] = useState([]);
  const [siteInfo, setSiteInfo] = useState(null);
  const [stats, setStats] = useState(null);
  const [avan, setAvan] = useState({});
  const [reports, setReports] = useState([]);
  const [tab, setTab] = useState('overview');
  const [loading, setLoading] = useState(true);
  const [velocity, setVelocity] = useState(null);
  const [plans, setPlans] = useState([]);
  const [selPlan, setSelPlan] = useState(null);
  const [planStatus, setPlanStatus] = useState([]);
  const [nights, setNights] = useState([]);
  const [manageZone, setManageZone] = useState(null);
  const [restants, setRestants] = useState([]);
  const isClient = user?.role === 'CLIENT';
  const canManage = ['BUREAU','ADMIN'].includes(user?.role);

  useEffect(() => {
    api.get('/sites').then(r => {
      setSites(r.data);
      if (!site && r.data.length) setSite(r.data.find(x => x.statut==='ACTIF') || r.data[0]);
    }).catch(()=>{});
    // eslint-disable-next-line
  }, []);
  useEffect(() => { if (site) fetchAll(); /* eslint-disable-next-line */ }, [site?.id]);
  const [planAnnotations, setPlanAnnotations] = useState([]);
  useEffect(() => {
    if (site && selPlan) {
      api.get(`/sites/${site.id}/plans/${selPlan.id}/status`)
        .then(x => setPlanStatus(x.data)).catch(()=>{});
      api.get(`/sites/${site.id}/plans/${selPlan.id}/annotations`)
        .then(x => setPlanAnnotations(x.data)).catch(()=>{});
    }
    // eslint-disable-next-line
  }, [selPlan?.id, site?.id]);

  async function fetchAll() {
    setLoading(true);
    try {
      const q = `?siteId=${site.id}`;
      const [s, a, r, si, v] = await Promise.all([
        api.get(`/dashboard/stats${q}`),
        api.get(`/dashboard/avancement${q}`),
        api.get(`/dashboard/recent${q}`),
        api.get(`/sites/${site.id}`),
        api.get(`/dashboard/velocity${q}`),
      ]);
      setStats(s.data); setAvan(a.data); setReports(r.data); setSiteInfo(si.data); setVelocity(v.data);
      if (canManage) api.get(`/sites/${site.id}/restants?open=1`).then(x => setRestants(x.data)).catch(()=>{});
      api.get(`/sites/${site.id}/plans`).then(x => {
        setPlans(x.data);
        setSelPlan(sp => sp && x.data.find(pl => pl.id === sp.id) ? sp : x.data[0] || null);
      }).catch(()=>{});
      api.get(`/sites/${site.id}/nights`).then(x => setNights(x.data)).catch(()=>{});
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  }

  async function openPdf(id) {
    try {
      const { data } = await api.get(`/reports/${id}/pdf`);
      if (data.path) window.open(data.path, '_blank');
    } catch { alert('Génération PDF impossible'); }
  }
  async function reject(id) {
    const reason = window.prompt('Motif du rejet (transmis au terrain) :');
    if (!reason) return;
    await api.post(`/reports/${id}/reject`, { reason });
    fetchAll();
  }
  async function toggleRestant(id) {
    await api.post(`/sites/${site.id}/restants/${id}/toggle`);
    api.get(`/sites/${site.id}/restants?open=1`).then(x => setRestants(x.data));
  }
  async function download(url, label) {
    try {
      const { data } = await api.get(url);
      if (data.path) window.open(data.path, '_blank');
    } catch { alert(`Génération ${label} impossible`); }
  }
  async function reopen(id) {
    if (!window.confirm('Rouvrir ce rapport ? Il repassera en brouillon modifiable par le terrain.')) return;
    await api.post(`/reports/${id}/reopen`);
    fetchAll();
  }

  const totalAP = stats?.totalAP || 0;
  const pctPose = totalAP ? Math.round((stats.apPoses / totalAP) * 100) : 0;

  return (
    <div style={styles.page}>
      <div style={styles.header} className="lw-band">
        <div className="lw-head-inner">
        <div>
          <h1 style={styles.title}>Tableau de bord</h1>
          <p style={styles.sub}>{user?.name}</p>
        </div>
        <div style={{display:'flex', gap:8, alignItems:'center', flexWrap:'wrap'}}>
          <select style={styles.siteSel} value={site?.id || ''}
            onChange={e => { const s = sites.find(x => x.id === e.target.value); if (s) setSite(s); }}>
            {sites.map(s => <option key={s.id} value={s.id}>{s.nom}</option>)}
          </select>
          {user?.role === 'ADMIN' &&
            <button style={styles.logoutBtn} onClick={() => nav('/admin')}>Admin</button>}
          <button style={styles.logoutBtn} onClick={logout}>Déconnexion</button>
        </div>
        </div>
      </div>

      {/* Tabs */}
      <div style={styles.tabs}>
        <div className="lw-tabs-inner">
        {[['overview','Vue globale'],
          ...(plans.length ? [['plan','Plan']] : []),
          ['rapports','Rapports'],['avancement','Avancement zones'],
          ...(canManage ? [['planning','Planning'],
                           ['restants',`Restants${restants.length?` (${restants.length})`:''}`],
                           ['livrables','Livrables']] : [])
        ].map(([t,l]) => (
          <button key={t} style={{...styles.tab,...(tab===t?styles.tabActive:{})}} onClick={()=>setTab(t)}>{l}</button>
        ))}
        </div>
      </div>

      {loading ? <div style={styles.loader}>Chargement...</div> : (
        <div className="lw-shell">

          {tab === 'overview' && stats && (
            <>
              <div className="lw-kpis">
                <KPI label="AP installés" value={`${stats.apPoses} / ${totalAP}`} color="#2E7D32"
                  sub={`${pctPose}% du chantier`}/>
                <KPI label="Câbles tirés" value={`${stats.cablesTires} / ${stats.totalNew}`} color="#2E75B6"
                  sub={stats.totalNew ? `${Math.round(stats.cablesTires/stats.totalNew*100)}% des nouveaux` : 'aucun nouveau câble'}/>
                <KPI label="Câbles réutilisés" value={`${stats.cablesReutil} / ${stats.totalReutil}`} color="#7A5AB8"
                  sub={stats.totalReutil ? `${Math.round(stats.cablesReutil/stats.totalReutil*100)}% des réutilisables` : 'aucun réutilisable'}/>
                <KPI label={`Rapports ${stats.currentSemaine || 'semaine'}`}
                  value={`${stats.currentWeekSubmitted} / 5`} color="#1E3A6E"
                  sub={`${stats.submitted} soumis au total`}/>
                <KPI label="Vélocité" value={velocity ? `${velocity.velocity}` : '—'} color="#2E75B6"
                  sub={velocity?.planDelta != null
                    ? `AP/nuit — ${velocity.planDelta >= 0 ? '+' : ''}${velocity.planDelta} vs plan`
                    : 'AP/nuit (5 dern. nuits)'}/>
                <KPI label="Fin projetée" color="#EF6C00"
                  value={velocity?.projectedEnd ? new Date(velocity.projectedEnd).toLocaleDateString('fr-FR') : '—'}
                  sub={velocity?.nightsLeft ? `~${velocity.nightsLeft} nuits restantes` : `${velocity?.remaining ?? '—'} AP restants`}/>
              </div>

              <div className="lw-cols">
                <div>
                  {velocity && velocity.series.length > 0 && (
                    <div style={styles.card}>
                      <p style={styles.cardTitle}>Rythme de pose</p>
                      <VelocityChart data={velocity}/>
                      <div style={{display:'flex', gap:18, marginTop:8, flexWrap:'wrap'}}>
                        <Stat label="Pose" value={`${velocity.velocity}/nuit`}/>
                        <Stat label="Tirage" value={`${velocity.velocityTire}/nuit`}/>
                        <Stat label="Réutilisation" value={`${velocity.velocityReutil}/nuit`}/>
                      </div>
                    </div>
                  )}
                  {stats.byWeek?.length > 0 && (
                    <div style={styles.card}>
                      <p style={styles.cardTitle}>Historique par semaine</p>
                      {stats.byWeek.map(w => (
                        <div key={w.semaine} style={{...styles.weekRow, alignItems:'center'}}>
                          <span style={{fontWeight:700,color:'#1E3A6E',minWidth:32}}>{w.semaine}</span>
                          <div style={styles.weekBar}>
                            <div style={{...styles.weekFill, width:`${Math.min(100,(w.submitted/5)*100)}%`}}/>
                          </div>
                          <span className="tnum" style={{fontSize:12,color:'#5A6478', whiteSpace:'nowrap'}}>
                            {w.submitted}/5 · {w.pose}p · {w.tire}t · {w.reutil}r
                          </span>
                          {canManage && (
                            <button style={{...styles.pdfBtn, padding:'4px 9px', fontSize:11}}
                              onClick={() => download(`/sites/${site.id}/compile?semaine=${w.semaine}`, 'consolidé')}>
                              PDF
                            </button>
                          )}
                        </div>
                      ))}
                      <p style={{fontSize:11, color:'#5A6478', marginTop:6}}>
                        p = posés · t = tirés · r = réutilisés — PDF : rapport hebdomadaire consolidé de la semaine
                      </p>
                    </div>
                  )}
                </div>
                <div>
                  <div style={styles.card}>
                    <p style={styles.cardTitle}>Avancement global</p>
                    <p className="tnum" style={{fontSize:34,fontWeight:800,color:'#13264D',marginBottom:6}}>{pctPose}<span style={{fontSize:18}}> %</span></p>
                    <div style={styles.progressBar}>
                      <div style={{...styles.progressFill, width:`${pctPose}%`}}/>
                    </div>
                    <p style={{fontSize:13,color:'#5A6478',marginTop:8}}>
                      {stats.apPoses} AP posés sur {totalAP}
                      {velocity ? ` — reste ${velocity.remaining}` : ''}
                    </p>
                  </div>
                  {siteInfo?.notes && (
                    <div style={{...styles.card, borderLeft:'4px solid #EF6C00', background:'#fff9f0'}}>
                      <p style={{color:'#EF6C00',fontWeight:700,marginBottom:8}}>Consignes chantier</p>
                      <p style={{fontSize:13, whiteSpace:'pre-wrap'}}>{siteInfo.notes}</p>
                    </div>
                  )}
                  {siteInfo && (
                    <div style={styles.card}>
                      <p style={styles.cardTitle}>Chantier</p>
                      <p style={{fontSize:13,color:'#5A6478'}}>
                        {[siteInfo.client, siteInfo.ville].filter(Boolean).join(' — ')}<br/>
                        {siteInfo.semaines?.length} semaines · {siteInfo.users?.length} intervenants
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}

          {tab === 'plan' && selPlan && (
            <div>
              <div style={{display:'flex', gap:6, flexWrap:'wrap', marginBottom:12}}>
                {plans.map(pl => (
                  <button key={pl.id} style={{...styles.pdfBtn,
                    background: selPlan.id===pl.id ? '#1E3A6E' : '#fff',
                    color: selPlan.id===pl.id ? '#fff' : '#1E3A6E',
                    border:'1px solid #1E3A6E'}}
                    onClick={()=>setSelPlan(pl)}>{pl.nom}</button>
                ))}
              </div>
              <div style={styles.card}>
                <PlanView imagePath={selPlan.imagePath} aps={planStatus}
                  annotations={planAnnotations}/>
                {planAnnotations.length > 0 && (
                  <p style={{fontSize:12, color:'#5A6478', marginTop:6}}>
                    {planAnnotations.length} annotation(s) terrain — gérables depuis l'app terrain ou par un admin
                  </p>
                )}
              </div>
            </div>
          )}

          {tab === 'planning' && canManage && (
            <PlanningTab site={site} nights={nights}
              refresh={() => api.get(`/sites/${site.id}/nights`).then(x => setNights(x.data))}/>
          )}

          {tab === 'rapports' && (
            <div>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
                <h2 style={{fontSize:17,fontWeight:700}}>Rapports récents</h2>
                <button style={styles.refreshBtn} onClick={fetchAll}>🔄</button>
              </div>
              <div className="lw-cards">
              {reports.map(r => (
                <div key={r.id} style={{...styles.reportCard, cursor:'default', marginBottom:0}}>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:8}}>
                    <div>
                      <span style={{fontWeight:700,color:'#1E3A6E'}}>{r.semaine} – {r.numJour} {r.jour}</span>
                      <p style={{fontSize:12,color:'#888'}}>{new Date(r.date).toLocaleDateString('fr')} | {r.chefEquipe?.name}</p>
                    </div>
                    <div style={{display:'flex',alignItems:'center',gap:6}}>
                      <span style={{...styles.statusBadge,
                        background:r.status==='SUBMITTED'?'#e8f5e9':'#fff9f0',
                        color:r.status==='SUBMITTED'?'#2E7D32':'#EF6C00'}}>
                        {r.status==='SUBMITTED'?'Soumis':'Brouillon'}
                      </span>
                      {r.status==='SUBMITTED' && (
                        <>
                          <button style={styles.pdfBtn} onClick={() => openPdf(r.id)}>PDF</button>
                          {canManage && (
                            <button style={{...styles.pdfBtn, background:'#fff', color:'#1E3A6E',
                              border:'1px solid #1E3A6E'}}
                              onClick={() => nav(`/rapport?edit=${r.id}`)}>Modifier</button>
                          )}
                        </>
                      )}
                      {r.status==='SUBMITTED' && canManage && (
                        <button style={styles.reopenBtn} onClick={() => reject(r.id)}>Rejeter</button>
                      )}
                      {r.status==='SUBMITTED' && user?.role==='ADMIN' && (
                        <button style={{...styles.reopenBtn, color:'#5A6478', borderColor:'#5A6478'}}
                          onClick={() => reopen(r.id)}>Rouvrir</button>
                      )}
                    </div>
                  </div>
                </div>
              ))}
              </div>
            </div>
          )}

          {tab === 'restants' && canManage && (
            <div>
              <h2 style={{fontSize:17,fontWeight:800,marginBottom:4}}>Restants à traiter</h2>
              <p style={{fontSize:13,color:'#5A6478',marginBottom:12}}>
                Issus des rapports soumis. Cocher quand c'est planifié ou fait — le terrain
                voit la liste ouverte en préparant sa nuit.
              </p>
              {restants.length === 0 && <p style={{color:'#2E7D32',fontWeight:600}}>Rien en attente.</p>}
              <div className="lw-cards-sm">
              {restants.map(r => (
                <div key={r.id} style={{...styles.reportCard, cursor:'default', marginBottom:0,
                  borderLeft:`3px solid ${r.priorite==='Haute'?'#C62828':r.priorite==='Moyenne'?'#EF6C00':'#2E75B6'}`}}>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:10}}>
                    <div>
                      <span style={{fontWeight:600}}>{r.tache}</span>
                      {r.quantite && <span style={{color:'#5A6478'}}> — {r.quantite}</span>}
                      <p style={{fontSize:12,color:'#888'}}>
                        {r.priorite || 'Moyenne'} · vu en {r.report.semaine} {r.report.numJour}
                        {r.note ? ` · ${r.note}` : ''}
                      </p>
                    </div>
                    <button style={styles.pdfBtn} onClick={()=>toggleRestant(r.id)}>Traité</button>
                  </div>
                </div>
              ))}
              </div>
            </div>
          )}

          {tab === 'livrables' && canManage && (
            <div>
              <h2 style={{fontSize:17,fontWeight:800,marginBottom:12}}>Livrables du chantier</h2>
              <div className="lw-cards">
              <Deliverable title="Dossier de recette (DOE)"
                desc="PDF par zone : dernier état de chaque AP, statuts, ping et photos."
                action={() => download(`/sites/${site.id}/doe`, 'DOE')} label="Générer le PDF"/>
              <Deliverable title="Archive complète"
                desc="ZIP : tous les rapports PDF + toutes les photos classées par nuit, + le DOE."
                action={() => download(`/sites/${site.id}/archive`, 'archive')} label="Générer le ZIP"/>
              <Deliverable title="Matériaux consommés"
                desc="Excel : détail par nuit + cumul par référence (réappro / facturation)."
                action={() => download(`/sites/${site.id}/export/materiaux`, 'export')} label="Exporter (.xlsx)"/>
              <Deliverable title="Heures par technicien"
                desc="Excel : pointages par nuit + totaux par technicien (paie)."
                action={() => download(`/sites/${site.id}/export/heures`, 'export')} label="Exporter (.xlsx)"/>
              <CompileCard site={site}/>
              <WeeklyCard site={site}/>
              </div>
            </div>
          )}

          {tab === 'avancement' && (
            <div>
              <div style={{display:'flex', justifyContent:'space-between', alignItems:'baseline', marginBottom:12, gap:8, flexWrap:'wrap'}}>
                <h2 style={{fontSize:17,fontWeight:800}}>Avancement par zone</h2>
                {canManage && (
                  <button style={{...styles.pdfBtn}}
                    onClick={() => {
                      const nom = window.prompt('Nom de la nouvelle zone :');
                      if (nom?.trim()) setManageZone(nom.trim());
                    }}>+ Nouvelle zone</button>
                )}
              </div>
              <div className="lw-cards-sm">
              {Object.entries(avan).map(([zone, z]) => {
                const total = z.total || 0;
                const pct = total ? Math.round((z.pose / total) * 100) : 0;
                const color = pct === 100 ? '#2E7D32' : pct > 50 ? '#1F4E79' : '#EF6C00';
                return (
                  <div key={zone} style={styles.zoneCard}>
                    <div style={{display:'flex',justifyContent:'space-between',marginBottom:6,gap:6}}>
                      <span style={{fontWeight:600,fontSize:14}}>{zone}</span>
                      <span style={{display:'flex',gap:8,alignItems:'center'}}>
                        <span style={{fontWeight:700,color, fontSize:14}}>{z.pose}/{total} AP</span>
                        {canManage && (
                          <button style={{fontSize:12,color:'#1E3A6E',fontWeight:700,
                            background:'none',textDecoration:'underline',padding:0}}
                            onClick={()=>setManageZone(zone)}>Gérer</button>
                        )}
                      </span>
                    </div>
                    <div style={styles.progressBar}>
                      <div style={{...styles.progressFill, width:`${pct}%`, background:color}}/>
                    </div>
                    <div style={{display:'flex',gap:12,marginTop:6,fontSize:12,color:'#666'}}>
                      <span>🔧 Tirés: {z.tire}</span>
                      <span>♻️ Réutil: {z.reutil}</span>
                      <span>📡 Posés: {z.pose}</span>
                      <span>✅ Pingés: {z.ping}</span>
                    </div>
                  </div>
                );
              })}
              </div>
            </div>
          )}
        </div>
      )}
      {manageZone && (
        <ZoneManager site={site} zone={manageZone}
          onClose={() => { setManageZone(null); fetchAll(); }}/>
      )}
    </div>
  );
}

function ZoneManager({ site, zone, onClose }) {
  const [aps, setAps] = useState(null);
  const [f, setF] = useState({ ref:'', type:'NEW', semaine:'S1', modele:'' });
  const [edit, setEdit] = useState(null);
  const [semaines, setSemaines] = useState(['S1']);
  const [zones, setZones] = useState([]);
  const load = () => {
    api.get(`/sites/${site.id}/ap`).then(r => setAps(r.data.filter(a => a.zone === zone)));
    api.get(`/sites/${site.id}/zones`).then(r => setZones(r.data.map(z => z.zone))).catch(()=>{});
  };
  useEffect(() => {
    load();
    api.get(`/sites/${site.id}`).then(({ data }) => {
      if (data.semaines?.length) { setSemaines(data.semaines); setF(x => ({...x, semaine: data.semaines[0]})); }
    });
    // eslint-disable-next-line
  }, []);

  async function add() {
    if (!f.ref.trim()) return;
    try {
      await api.post(`/sites/${site.id}/ap`, { ...f, ref: f.ref.trim(), zone });
      setF(x => ({ ...x, ref:'', modele:'' })); load();
    } catch (e) { alert(e.response?.data?.error || 'Ajout impossible'); }
  }
  async function saveEdit() {
    try {
      await api.put(`/sites/${site.id}/ap/${edit.id}`, edit);
      setEdit(null); load();
    } catch (e) { alert(e.response?.data?.error || 'Modification impossible'); }
  }
  async function remove(a) {
    if (!window.confirm(`Supprimer l'AP ${a.ref} du chantier ?`)) return;
    try { await api.delete(`/sites/${site.id}/ap/${a.id}`); load(); }
    catch (e) { alert(e.response?.data?.error || 'Suppression impossible'); }
  }
  async function renameZone() {
    const to = window.prompt(`Renommer la zone « ${zone} » en :`, zone);
    if (!to?.trim() || to === zone) return;
    await api.put(`/sites/${site.id}/zones/rename`, { from: zone, to: to.trim() });
    onClose();
  }
  async function deleteZone() {
    if (!aps?.length) { onClose(); return; }
    const typed = window.prompt(
      `Suppression de la zone et de ses ${aps.length} AP (positions plan comprises).\n` +
      `L'historique des rapports soumis est conservé.\nPour confirmer, tapez : ${zone}`);
    if (typed !== zone) return;
    try {
      await api.delete(`/sites/${site.id}/zones?zone=${encodeURIComponent(zone)}`);
      onClose();
    } catch (e) { alert(e.response?.data?.error || 'Suppression impossible'); }
  }

  return (
    <div style={zmS.wrap} onClick={onClose}>
      <div style={zmS.modal} onClick={e => e.stopPropagation()}>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:4, gap:8, flexWrap:'wrap'}}>
          <p style={{fontWeight:800, color:'#13264D', fontSize:16}}>Zone « {zone} »</p>
          <div style={{display:'flex', gap:6, flexWrap:'wrap'}}>
            <button style={zmS.ghost} onClick={renameZone}>Renommer</button>
            <button style={{...zmS.ghost, color:'#C62828', borderColor:'#f3c1c1'}}
              onClick={deleteZone}>Supprimer la zone</button>
            <button style={zmS.close} onClick={onClose}>Fermer</button>
          </div>
        </div>
        <p style={{fontSize:12, color:'#5A6478', marginBottom:12}}>
          {aps === null ? '…' : `${aps.length} AP`} — ajout, édition et suppression ci-dessous.
          {aps?.length === 0 && " Zone nouvelle : elle existera dès le premier AP ajouté."}
        </p>
        <div style={zmS.addGrid}>
          <input style={zmS.inp} placeholder="Référence AP *" value={f.ref}
            onChange={e=>setF(x=>({...x,ref:e.target.value}))}
            onKeyDown={e=>e.key==='Enter'&&add()}/>
          <select style={zmS.inp} value={f.type} onChange={e=>setF(x=>({...x,type:e.target.value}))}>
            <option value="NEW">NEW</option><option value="REUTIL">RÉUTIL</option>
            <option value="AVERIFIER">À VÉRIF.</option>
          </select>
          <select style={zmS.inp} value={f.semaine} onChange={e=>setF(x=>({...x,semaine:e.target.value}))}>
            {semaines.map(sx => <option key={sx}>{sx}</option>)}
          </select>
          <input style={zmS.inp} placeholder="Modèle" value={f.modele}
            onChange={e=>setF(x=>({...x,modele:e.target.value}))}/>
          <button style={zmS.add} onClick={add}>+ Ajouter</button>
        </div>
        <div style={{maxHeight:420, overflowY:'auto'}}>
          {aps === null && <p style={{fontSize:13, color:'#5A6478'}}>Chargement…</p>}
          {aps?.map(a => edit?.id === a.id ? (
            <div key={a.id} style={{...zmS.addGrid, padding:'8px 0', borderBottom:'1px solid #F0F3F9', marginBottom:0}}>
              <input style={zmS.inp} value={edit.ref}
                onChange={e=>setEdit(x=>({...x,ref:e.target.value}))}/>
              <select style={zmS.inp} value={edit.type} onChange={e=>setEdit(x=>({...x,type:e.target.value}))}>
                <option value="NEW">NEW</option><option value="REUTIL">RÉUTIL</option>
                <option value="AVERIFIER">À VÉRIF.</option>
              </select>
              <select style={zmS.inp} value={edit.semaine} onChange={e=>setEdit(x=>({...x,semaine:e.target.value}))}>
                {semaines.map(sx => <option key={sx}>{sx}</option>)}
              </select>
              <select style={zmS.inp} value={edit.zone} title="Zone"
                onChange={e=>setEdit(x=>({...x,zone:e.target.value}))}>
                {[...new Set([zone, ...zones])].map(zx => <option key={zx}>{zx}</option>)}
              </select>
              <span style={{display:'flex', gap:6}}>
                <button style={zmS.add} onClick={saveEdit}>OK</button>
                <button style={zmS.ghost} onClick={()=>setEdit(null)}>✕</button>
              </span>
            </div>
          ) : (
            <div key={a.id} style={zmS.row}>
              <span><b>{a.ref}</b> <span style={{color:'#5A6478', fontSize:12}}>· {a.semaine} · {a.type}{a.modele ? ` · ${a.modele}` : ''}</span></span>
              <span style={{display:'flex', gap:10}}>
                <button style={zmS.link} onClick={() => setEdit({ id:a.id, ref:a.ref,
                  type:a.type, semaine:a.semaine, modele:a.modele||'', zone:a.zone })}>Éditer</button>
                <button style={zmS.del} onClick={() => remove(a)}>Supprimer</button>
              </span>
            </div>
          ))}
          {aps?.length === 0 && <p style={{fontSize:13, color:'#5A6478'}}>Aucun AP dans cette zone.</p>}
        </div>
        <p style={{fontSize:11, color:'#8A6D00', marginTop:10}}>
          Renommer une référence ne réécrit pas l'historique des rapports déjà soumis ;
          la suppression conserve aussi cet historique. Le modèle s'édite via la référence.
        </p>
      </div>
    </div>
  );
}
const zmS = {
  wrap:{ position:'fixed', inset:0, background:'rgba(19,38,77,.55)', zIndex:60,
         display:'flex', alignItems:'center', justifyContent:'center', padding:14 },
  modal:{ background:'#fff', borderRadius:14, padding:18, width:'100%', maxWidth:760,
          maxHeight:'90vh', overflowY:'auto' },
  inp:{ border:'1.5px solid #DDE4F0', borderRadius:8, padding:'8px 10px', fontSize:13, minWidth:0 },
  add:{ background:'#1E3A6E', color:'#fff', borderRadius:8, padding:'8px 12px', fontSize:13, fontWeight:700 },
  row:{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:8,
        padding:'7px 0', borderBottom:'1px solid #F0F3F9', fontSize:14, flexWrap:'wrap' },
  del:{ background:'none', color:'#C62828', fontSize:12, textDecoration:'underline', padding:0 },
  link:{ background:'none', color:'#1E3A6E', fontSize:12, textDecoration:'underline', padding:0 },
  ghost:{ background:'#fff', color:'#1E3A6E', border:'1.5px solid #DDE4F0', borderRadius:8,
          padding:'6px 10px', fontSize:12, fontWeight:600 },
  close:{ background:'#1E3A6E', color:'#fff', borderRadius:8, padding:'6px 12px', fontSize:12, fontWeight:600 },
  addGrid:{ display:'grid', gridTemplateColumns:'1.5fr 0.9fr 0.8fr 1.1fr auto', gap:6,
            marginBottom:12, alignItems:'center' },
};

function PlanningTab({ site, nights, refresh }) {
  const [f, setF] = useState({ date:'', semaine:'S1', numJour:'J1', objPose:'', objTirage:'', note:'' });
  const [semaines, setSemaines] = useState(['S1']);
  const [genSem, setGenSem] = useState('S1');
  const [genStart, setGenStart] = useState(new Date().toISOString().slice(0,10));
  const fileInput = { current: null };

  async function importXlsx(file) {
    const fd = new FormData(); fd.append('file', file);
    try {
      const { data } = await api.post(`/sites/${site.id}/nights/import`, fd,
        { headers: { 'Content-Type': 'multipart/form-data' } });
      alert(`${data.imported} nuit(s) importée(s)${data.errors.length ? ` — ${data.errors.length} ligne(s) ignorée(s)` : ''}`);
      refresh();
    } catch (e) { alert(e.response?.data?.error || 'Import impossible'); }
  }
  async function generate() {
    try {
      const { data } = await api.post(`/sites/${site.id}/nights/generate`,
        { semaine: genSem, startDate: genStart, nbNights: 5 });
      alert(`${data.created} nuit(s) planifiée(s) — ${data.totalNew} nouveaux + ${data.totalReutil} réutilisés répartis (réutilisés en fin de semaine)`);
      refresh();
    } catch (e) { alert(e.response?.data?.error || 'Génération impossible'); }
  }
  useEffect(() => {
    api.get(`/sites/${site.id}`).then(({ data }) => {
      if (data.semaines?.length) {
        setSemaines(data.semaines);
        setF(x => ({...x, semaine: data.semaines[0]}));
        setGenSem(data.semaines[0]);
      }
    });
    // eslint-disable-next-line
  }, [site.id]);

  async function add() {
    if (!f.date) return;
    await api.post(`/sites/${site.id}/nights`, {
      ...f, objPose: f.objPose || null, objTirage: f.objTirage || null });
    setF(x => ({ ...x, date:'', objPose:'', objTirage:'', note:'' }));
    refresh();
  }
  async function remove(id) { await api.delete(`/sites/${site.id}/nights/${id}`); refresh(); }

  const today = new Date().toISOString().slice(0,10);
  return (
    <div>
      <h2 style={{fontSize:17,fontWeight:800,marginBottom:4}}>Planning des nuits</h2>
      <p style={{fontSize:13,color:'#5A6478',marginBottom:12}}>
        Le terrain retrouve sa nuit pré-remplie ; le réalisé se rapproche du planifié automatiquement.
      </p>
      <div style={styles.card}>
        <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(130px,1fr))', gap:8}}>
          <input style={pIn} type="date" value={f.date} onChange={e=>setF(x=>({...x,date:e.target.value}))}/>
          <select style={pIn} value={f.semaine} onChange={e=>setF(x=>({...x,semaine:e.target.value}))}>
            {semaines.map(s => <option key={s}>{s}</option>)}
          </select>
          <input style={pIn} placeholder="Jour (J12)" value={f.numJour}
            onChange={e=>setF(x=>({...x,numJour:e.target.value}))}/>
          <input style={pIn} type="number" placeholder="Obj. pose" value={f.objPose}
            onChange={e=>setF(x=>({...x,objPose:e.target.value}))}/>
          <input style={pIn} type="number" placeholder="Obj. tirage" value={f.objTirage}
            onChange={e=>setF(x=>({...x,objTirage:e.target.value}))}/>
          <button style={styles.pdfBtn} onClick={add}>Planifier</button>
        </div>
        <input style={{...pIn, width:'100%', marginTop:8}} placeholder="Note / consigne pour cette nuit"
          value={f.note} onChange={e=>setF(x=>({...x,note:e.target.value}))}/>
      </div>
      <div className="lw-cols" style={{marginBottom:12}}>
        <div style={styles.card}>
          <p style={{fontWeight:700, color:'#13264D', marginBottom:4}}>Génération automatique</p>
          <p style={{fontSize:12, color:'#5A6478', marginBottom:8}}>
            Répartit les AP de la semaine sur 5 nuits ouvrées : nouveaux câbles + pose d'abord,
            réutilisés planifiés ensuite.
          </p>
          <div style={{display:'flex', gap:8, flexWrap:'wrap', alignItems:'center'}}>
            <select style={pIn} value={genSem} onChange={e=>setGenSem(e.target.value)}>
              {semaines.map(sx => <option key={sx}>{sx}</option>)}
            </select>
            <input type="date" style={pIn} value={genStart} onChange={e=>setGenStart(e.target.value)}/>
            <button style={styles.pdfBtn} onClick={generate}>Générer les 5 nuits</button>
          </div>
        </div>
        <div style={styles.card}>
          <p style={{fontWeight:700, color:'#13264D', marginBottom:4}}>Import Excel</p>
          <p style={{fontSize:12, color:'#5A6478', marginBottom:8}}>
            Colonnes détectées automatiquement : date, semaine, jour, objectif pose/bornes,
            objectif tirage/câbles, note. Les dates existantes sont mises à jour.
          </p>
          <input type="file" accept=".xlsx" style={{display:'none'}}
            ref={el => { fileInput.current = el; }}
            onChange={e => e.target.files[0] && importXlsx(e.target.files[0])}/>
          <button style={{...styles.pdfBtn, background:'#2E75B6'}}
            onClick={() => fileInput.current?.click()}>Importer un planning (.xlsx)</button>
        </div>
      </div>
      <div className="lw-cards-sm">
        {nights.map(n => {
          const past = n.date.slice(0,10) < today;
          const hit = n.realise != null && n.objPose != null
            ? (n.realise >= n.objPose ? 'ok' : 'ko') : null;
          return (
            <div key={n.id} style={{...styles.reportCard, cursor:'default', marginBottom:0,
              opacity: past && n.realise == null ? .6 : 1,
              borderLeft:`3px solid ${hit==='ok'?'#2E7D32':hit==='ko'?'#C62828':'#2E75B6'}`}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:8}}>
                <div>
                  <span style={{fontWeight:700,color:'#13264D'}}>
                    {new Date(n.date).toLocaleDateString('fr-FR')} — {n.semaine} {n.numJour}
                  </span>
                  <p className="tnum" style={{fontSize:13,color:'#5A6478'}}>
                    Objectif : {n.objPose ?? '—'} poses{n.objTirage ? `, ${n.objTirage} tirages` : ''}
                    {n.realise != null && <> · Réalisé : <b style={{color:hit==='ok'?'#2E7D32':'#C62828'}}>{n.realise}</b></>}
                  </p>
                  {n.note && <p style={{fontSize:12,color:'#888'}}>{n.note}</p>}
                </div>
                <button style={styles.reopenBtn} onClick={()=>remove(n.id)}>✕</button>
              </div>
            </div>
          );
        })}
        {nights.length === 0 && <p style={{color:'#5A6478'}}>Aucune nuit planifiée. La planification alimente le pré-remplissage terrain et l'écart au plan.</p>}
      </div>
    </div>
  );
}
const pIn = { border:'1.5px solid #DDE4F0', borderRadius:10, padding:'9px 11px', fontSize:14 };

function Stat({ label, value }) {
  return (
    <div>
      <p style={{fontSize:12,color:'#5A6478'}}>{label}</p>
      <p className="tnum" style={{fontSize:16,fontWeight:800,color:'#13264D'}}>{value}</p>
    </div>
  );
}

// Barres = AP posés par nuit ; ligne = cumul (SVG pur, zéro dépendance)
function VelocityChart({ data }) {
  const W = 560, H = 150, PAD = 24;
  const series = data.series.slice(-30);
  const maxPose = Math.max(...series.map(x => x.pose), 1);
  const maxCumul = Math.max(data.totalAP, ...series.map(x => x.cumul), 1);
  const bw = (W - PAD * 2) / series.length;
  const yPose = v => H - PAD - (v / maxPose) * (H - PAD * 2);
  const yCum  = v => H - PAD - (v / maxCumul) * (H - PAD * 2);
  const line = series.map((x, i) =>
    `${i === 0 ? 'M' : 'L'}${PAD + i * bw + bw / 2},${yCum(x.cumul)}`).join(' ');
  return (
    <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%', height:'auto'}}>
      <line x1={PAD} y1={H-PAD} x2={W-PAD} y2={H-PAD} stroke="#DDE4F0"/>
      {series.map((x, i) => (
        <rect key={i} x={PAD + i * bw + 1.5} y={yPose(x.pose)}
          width={Math.max(2, bw - 3)} height={H - PAD - yPose(x.pose)}
          rx={2} fill="#2E75B6" opacity=".85"/>
      ))}
      <path d={line} fill="none" stroke="#FFC91F" strokeWidth="2.5"/>
      <line x1={PAD} y1={yCum(data.totalAP)} x2={W-PAD} y2={yCum(data.totalAP)}
        stroke="#2E7D32" strokeDasharray="5 4" strokeWidth="1.5"/>
      <text x={W-PAD} y={yCum(data.totalAP)-4} textAnchor="end" fontSize="10" fill="#2E7D32">
        objectif {data.totalAP} AP
      </text>
    </svg>
  );
}

function WeeklyCard({ site }) {
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  async function preview() {
    setBusy(true);
    try {
      const { data } = await api.post(`/sites/${site.id}/weekly-preview`, { message });
      if (data.path) window.open(data.path, '_blank');
    } catch { alert('Prévisualisation impossible'); }
    finally { setBusy(false); }
  }
  async function send() {
    if (!window.confirm('Envoyer la synthèse hebdomadaire aux comptes CLIENT du chantier ?')) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/sites/${site.id}/weekly-email`, { message });
      alert(data.sent ? `Synthèse envoyée à : ${data.recipients}` : `Non envoyée : ${data.reason}`);
    } catch { alert('Envoi impossible (SMTP configuré ?)'); }
    finally { setBusy(false); }
  }
  return (
    <div style={{background:'#fff', borderRadius:14, padding:18,
      border:'1px solid #DDE4F0', boxShadow:'0 1px 2px rgba(19,38,77,.06)',
      display:'flex', flexDirection:'column', gap:10, height:'100%'}}>
      <div>
        <p style={{fontWeight:700, color:'#13264D', fontSize:15}}>Synthèse hebdomadaire</p>
        <p style={{fontSize:13, color:'#5A6478', marginTop:4}}>
          Envoyée automatiquement chaque lundi 07h aux comptes CLIENT du chantier.
          Prévisualisez, ajoutez un commentaire, puis envoyez.
        </p>
      </div>
      <textarea rows={2} placeholder="Commentaire du bureau (facultatif — intégré au PDF et au mail)"
        style={{border:'1.5px solid #DDE4F0', borderRadius:10, padding:'8px 10px', fontSize:13, fontFamily:'inherit'}}
        value={message} onChange={e=>setMessage(e.target.value)}/>
      <div style={{display:'flex', gap:8}}>
        <button disabled={busy} style={{background:'#fff', color:'#1E3A6E', border:'1.5px solid #1E3A6E',
          borderRadius:10, padding:'10px 16px', fontSize:13, fontWeight:700}}
          onClick={preview}>Prévisualiser</button>
        <button disabled={busy} style={{background:'#1E3A6E', color:'#fff', borderRadius:10,
          padding:'10px 16px', fontSize:13, fontWeight:700}}
          onClick={send}>Envoyer</button>
      </div>
    </div>
  );
}

function CompileCard({ site }) {
  const today = new Date();
  const weekAgo = new Date(today.getTime() - 6 * 86400000);
  const iso = d => d.toISOString().slice(0, 10);
  const [from, setFrom] = useState(iso(weekAgo));
  const [to, setTo] = useState(iso(today));
  const [busy, setBusy] = useState(false);

  function preset(days) {
    setFrom(iso(new Date(today.getTime() - (days - 1) * 86400000)));
    setTo(iso(today));
  }
  async function go() {
    setBusy(true);
    try {
      const { data } = await api.get(`/sites/${site.id}/compile?from=${from}&to=${to}`);
      if (data.path) window.open(data.path, '_blank');
    } catch (e) { alert(e.response?.data?.error || 'Génération impossible'); }
    finally { setBusy(false); }
  }

  return (
    <div style={{background:'#fff', borderRadius:14, padding:18,
      border:'1px solid #DDE4F0', boxShadow:'0 1px 2px rgba(19,38,77,.06)',
      display:'flex', flexDirection:'column', gap:10, height:'100%'}}>
      <div>
        <p style={{fontWeight:700, color:'#13264D', fontSize:15}}>Rapport consolidé</p>
        <p style={{fontSize:13, color:'#5A6478', marginTop:4}}>
          Compile les rapports d'une période au choix en un PDF : synthèse, détail nuit par nuit,
          pose par zone, heures, matériaux, incidents.
        </p>
      </div>
      <div style={{display:'flex', gap:6, flexWrap:'wrap'}}>
        <button style={cpChip} onClick={() => preset(7)}>7 jours</button>
        <button style={cpChip} onClick={() => preset(14)}>14 jours</button>
        <button style={cpChip} onClick={() => preset(30)}>30 jours</button>
      </div>
      <div style={{display:'flex', gap:8, alignItems:'center', flexWrap:'wrap'}}>
        <input type="date" style={cpIn} value={from} onChange={e=>setFrom(e.target.value)}/>
        <span style={{color:'#5A6478'}}>→</span>
        <input type="date" style={cpIn} value={to} onChange={e=>setTo(e.target.value)}/>
      </div>
      <button disabled={busy} style={{background:'#1E3A6E', color:'#fff', borderRadius:10,
        alignSelf:'flex-start', padding:'10px 16px', fontSize:13, fontWeight:700}}
        onClick={go}>{busy ? 'Génération…' : 'Générer le PDF'}</button>
    </div>
  );
}
const cpIn = { border:'1.5px solid #DDE4F0', borderRadius:10, padding:'8px 10px', fontSize:13 };
const cpChip = { border:'1.5px solid #DDE4F0', borderRadius:20, padding:'4px 12px',
  fontSize:12, background:'#fff', color:'#1E3A6E', fontWeight:600 };

function Deliverable({ title, desc, action, label }) {
  return (
    <div style={{background:'#fff', borderRadius:14, padding:18,
      border:'1px solid #DDE4F0', boxShadow:'0 1px 2px rgba(19,38,77,.06)',
      display:'flex', flexDirection:'column', justifyContent:'space-between', gap:14, height:'100%'}}>
      <div>
        <p style={{fontWeight:700, color:'#13264D', fontSize:15}}>{title}</p>
        <p style={{fontSize:13, color:'#5A6478', marginTop:4}}>{desc}</p>
      </div>
      <button style={{background:'#1E3A6E', color:'#fff', borderRadius:10, alignSelf:'flex-start',
        padding:'10px 16px', fontSize:13, fontWeight:700}} onClick={action}>{label}</button>
    </div>
  );
}

function KPI({ label, value, color, sub }) {
  return (
    <div style={{...styles.card, textAlign:'center', borderTop:`4px solid ${color}`}}>
      <p style={{fontSize:28,fontWeight:800,color}}>{value}</p>
      <p style={{fontWeight:600,fontSize:14,marginTop:4}}>{label}</p>
      {sub && <p style={{fontSize:12,color:'#888',marginTop:2}}>{sub}</p>}
    </div>
  );
}

const styles = {
  page:{ minHeight:'100vh' },
  header:{ color:'#fff', padding:'20px 24px',
           display:'flex', justifyContent:'space-between', alignItems:'center' },
  title:{ fontSize:20, fontWeight:800, margin:0 },
  sub:{ fontSize:13, opacity:.8, marginTop:4 },
  logoutBtn:{ background:'rgba(255,255,255,.2)', border:'none', color:'#fff',
              padding:'8px 16px', borderRadius:8, cursor:'pointer', fontSize:13 },
  siteSel:{ background:'rgba(255,255,255,.95)', border:'none', color:'#1E3A6E', fontWeight:700,
            padding:'8px 12px', borderRadius:8, fontSize:13, maxWidth:220 },
  tabs:{ background:'#fff', borderBottom:'1px solid #DDE4F0' },
  tab:{ padding:'14px 20px', border:'none', background:'none', fontSize:14,
        cursor:'pointer', color:'#666', fontWeight:500,
        borderBottom:'3px solid transparent' },
  tabActive:{ color:'#13264D', borderBottomColor:'#FFC91F', fontWeight:800 },
  content:{ padding:'20px 16px' },
  loader:{ textAlign:'center', padding:40, color:'#888' },
  kpiGrid:{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:16 },
  card:{ background:'#fff', borderRadius:14, padding:16, marginBottom:12,
         border:'1px solid #DDE4F0',
         boxShadow:'0 1px 2px rgba(19,38,77,.06), 0 4px 14px rgba(19,38,77,.05)' },
  cardTitle:{ fontWeight:700, fontSize:15, marginBottom:10, color:'#333' },
  progressBar:{ height:12, background:'#eee', borderRadius:6, overflow:'hidden' },
  progressFill:{ height:'100%', background:'#1E3A6E', borderRadius:6,
                 transition:'width .5s ease' },
  weekRow:{ display:'flex', alignItems:'center', gap:10, marginBottom:8 },
  weekBar:{ flex:1, height:8, background:'#eee', borderRadius:4, overflow:'hidden' },
  weekFill:{ height:'100%', background:'#2E75B6', borderRadius:4 },
  reportCard:{ background:'#fff', borderRadius:10, padding:'14px 16px', marginBottom:8,
               boxShadow:'0 1px 3px rgba(0,0,0,.06)', cursor:'pointer',
               borderLeft:'3px solid #2E75B6' },
  statusBadge:{ padding:'4px 10px', borderRadius:20, fontSize:12, fontWeight:600 },
  zoneCard:{ background:'#fff', borderRadius:12, padding:14,
             border:'1px solid #DDE4F0', boxShadow:'0 1px 3px rgba(19,38,77,.06)' },
  pdfBtn:{ background:'#1E3A6E', color:'#fff', border:'none', borderRadius:6,
           padding:'5px 12px', fontSize:12, fontWeight:700, cursor:'pointer' },
  reopenBtn:{ background:'#fff', color:'#EF6C00', border:'1px solid #EF6C00', borderRadius:6,
              padding:'5px 10px', fontSize:12, fontWeight:600, cursor:'pointer' },
  refreshBtn:{ background:'#eee', border:'none', borderRadius:8, padding:'8px 12px', cursor:'pointer', fontSize:16 },
};
